export const setTDWidth = (w) =>  {
    return {
        width: `${w}px`,
        minWidth: `${w}px`,
        maxWidth: `${w}px`
    };
}
